export*from"./general";
